import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectLogs({ errorText, ...props }) {
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl  variant="standard" fullWidth>
        <InputLabel>Status</InputLabel>
        <Select
          sx={{height:"50px"}}
          labelId="demo-simple-select-label"
          value={age}
          label="Status"
          onChange={handleChange}
          {...props}
        >
           <MenuItem value={"Sucesso"}>Sucesso</MenuItem>
          <MenuItem value={"Erro"}>Erro</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

        